import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          {/* Decorative angled blocks */}
          <div className="relative">
            <div className="absolute -left-4 top-0 w-2 h-20 bg-primary-500/20 rounded-sm transform -rotate-6 hidden lg:block"></div>
            <div className="absolute -right-4 top-10 w-2 h-16 bg-accent-500/20 rounded-sm transform rotate-6 hidden lg:block"></div>

            <div className="bg-background-50 rounded-2xl px-6 md:px-10 py-10 md:py-12">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">

                {/* Brand */}
                <div>
                  <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                    <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                      <i className="ri-grid-line text-white text-sm"></i>
                    </div>
                    <span className="text-base font-semibold text-foreground-900 whitespace-nowrap">
                      ACBuySpreadsheet
                    </span>
                  </Link>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    The most advanced acbuyspreadsheet framework for data tracking, automation, and optimization. Compare tools, learn workflows, and improve your spreadsheet efficiency.
                  </p>
                </div>

                {/* Categories */}
                <div>
                  <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                    CATEGORIES
                  </h4>
                  <ul className="space-y-2.5">
                    {categories.slice(0, 6).map((cat) => (
                      <li key={cat.slug}>
                        <a
                          href={cat.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                        >
                          {cat.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* More Categories */}
                <div>
                  <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                    MORE CATEGORIES
                  </h4>
                  <ul className="space-y-2.5">
                    {categories.slice(6, 12).map((cat) => (
                      <li key={cat.slug}>
                        <a
                          href={cat.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                        >
                          {cat.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Guides & Legal */}
                <div>
                  <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                    GUIDES
                  </h4>
                  <ul className="space-y-2.5">
                    <li>
                      <Link to="/article/acbuyspreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap">
                        Beginner Guide
                      </Link>
                    </li>
                    <li>
                      <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap">
                        Home
                      </Link>
                    </li>
                    <li>
                      <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap">
                        Main Site
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-8 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4 text-xs text-foreground-500 flex-wrap justify-center">
              <span>&copy; 2026 ACBuySpreadsheet. All rights reserved.</span>
              <span className="hidden sm:inline text-foreground-300">|</span>
              <span>Privacy Policy</span>
              <span className="hidden sm:inline text-foreground-300">|</span>
              <span>Terms of Service</span>
            </div>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center cursor-pointer hover:bg-foreground-900 transition-colors">
                <i className="ri-twitter-x-line text-white text-xs"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center cursor-pointer hover:bg-foreground-900 transition-colors">
                <i className="ri-linkedin-fill text-white text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}